import ScreenRecordingIcon from "../../Resources/record-screen.svg?react";
import RoomScanIcon from "../../Resources/room-scan.svg?react";
import RecordVideoIcon from "../../Resources/record-video.svg?react";
import BlockVirtualMachinesIcon from "../../Resources/block-virtual-machines.svg?react";
import RecordAppsActivity from "../../Resources/record-apps-activity.svg?react";
import RecordWebTrafficIcon from "../../Resources/record-web-traffic.svg?react";
import DetectSidePanelIcon from "../../Resources/side-panel.svg?react";
import CloseTabsIcon from "../../Resources/close-open-tabs.svg?react";
import DisableClipboardIcon from "../../Resources/disable-clipboard.svg?react";
import GuidedAccess from "../../Resources/guided-access.svg?react";
import RestrictHandoff from "../../Resources/restrict-handoff.svg?react";
import DisableDownloadFilesIcon from "../../Resources/disable-download.svg?react";
import DisableNewTabIcon from "../../Resources/disable-new-tab.svg?react";
import DisablePrintingIcon from "../../Resources/disable-printing.svg?react";
import DisableRightClickIcon from "../../Resources/disable-right-click.svg?react";
import DisableExtensionsIcon from "../../Resources/disable-extensions.svg?react";
import DisableSpellCheckIcon from "../../Resources/disable-spellcheck.svg?react";
import FaceTrackingIcon from "../../Resources/face-tracking.svg?react";
import HideOtherWindowsIcon from "../../Resources/hide-other-windows.svg?react";
import IdVerificationIcon from "../../Resources/id-check.svg?react";
import ObjectDetectionIcon from "../../Resources/object-detection.svg?react";
import OneScreenEnforcementIcon from "../../Resources/display-check.svg?react";
import RecordInputIcon from "../../Resources/record-keyboard.svg?react";
import RecordAudioIcon from "../../Resources/record-audio.svg?react";
import CalculatorIcon from "../../Resources/calculator.svg?react";
import WhiteBoardIcon from "../../Resources/whiteboard.svg?react";
import BrowserExtensionIcon from "../../Resources/browser-extension.svg?react";
import LockdownAppIcon from "../../Resources/lockdownApp.svg?react";
import SignatureIcon from "../../../../images/reports/signature.svg?react";
import LogInstalledExtensionsIcon from "../../Resources/log-installed-extensions.svg?react";
import ViewRunningApplicationsIcon from "../../Resources/view-running-applications.svg?react";
import { VideoEvent } from "../../../utilities/useTimestamps";
import i18n from "../../../../i18n";

const proctoringOptions = [
	{
		key: "recordScreen",
		icon: ScreenRecordingIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.screenRecording"),
	},
	{ key: "scanRoom", icon: RoomScanIcon, label: i18n.t("result.components.resultsPage.pdfGenerator.scanRoom") },
	{
		key: "videoRecordingMode",
		icon: RecordVideoIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.videoRecordingMode"),
	},
	{
		key: "blockVirtualMachines",
		icon: BlockVirtualMachinesIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.blockVirtualMachines"),
	},
	{
		key: "recordApplicationsActivity",
		icon: RecordAppsActivity,
		label: i18n.t("result.components.resultsPage.pdfGenerator.recordApplicationsActivity"),
	},
	{
		key: "recordWebTraffic",
		icon: RecordWebTrafficIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.recordWebTraffic"),
	},
	{
		key: "detectSidePanel",
		icon: DetectSidePanelIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.detectSidePanel"),
	},
	{
		key: "closeOpenTabs",
		icon: CloseTabsIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.closeOpenTabs"),
	},
	{
		key: "disableClipboardMode",
		icon: DisableClipboardIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.disableClipboardMode"),
	},
	{
		key: "enableGuidedAccessMode",
		icon: GuidedAccess,
		label: i18n.t("result.components.resultsPage.pdfGenerator.enableGuidedAccessMode"),
	},
	{
		key: "restrictHandoffMode",
		icon: RestrictHandoff,
		label: i18n.t("result.components.resultsPage.pdfGenerator.restrictHandoffMode"),
	},
	{
		key: "disableDownloadFiles",
		icon: DisableDownloadFilesIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.disableDownloadFiles"),
	},
	{
		key: "disableNewTab",
		icon: DisableNewTabIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.disableNewTab"),
	},
	{
		key: "disablePrinting",
		icon: DisablePrintingIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.disablePrinting"),
	},
	{
		key: "disableRightClick",
		icon: DisableRightClickIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.disableRightClick"),
	},
	{
		key: "extensionBlockMode",
		icon: DisableExtensionsIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.extensionBlockMode"),
	},
	{
		key: "logInstalledExtensions",
		icon: LogInstalledExtensionsIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.logInstalledExtensions"),
	},
	{
		key: "logRunningApplications",
		icon: ViewRunningApplicationsIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.logRunningApplications") as string,
	},
	{
		key: "disableSpellcheck",
		icon: DisableSpellCheckIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.disableSpellcheck"),
	},
	{
		key: "faceTrackingMode",
		icon: FaceTrackingIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.faceTrackingMode"),
	},
	{
		key: "hideOtherWindows",
		icon: HideOtherWindowsIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.hideOtherWindows"),
	},
	{
		key: "idVerification",
		icon: IdVerificationIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.idVerification"),
	},
	{
		key: "objectDetectionMode",
		icon: ObjectDetectionIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.objectDetectionMode"),
	},
	{
		key: "oneScreenEnforcementMode",
		icon: OneScreenEnforcementIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.oneScreenEnforcementMode"),
	},
	{
		key: "recordInput",
		icon: RecordInputIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.recordInput"),
	},
	{
		key: "audioRecordingMode",
		icon: RecordAudioIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.audioRecordingMode"),
	},
	{
		key: "enableCalculator",
		icon: CalculatorIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.enableCalculator"),
	},
	{
		key: "enableWhiteboard",
		icon: WhiteBoardIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.enableWhiteboard"),
	},
	{
		key: "uploadSignature",
		icon: SignatureIcon,
		label: i18n.t("result.components.resultsPage.pdfGenerator.uploadSignature"),
	},
];

const ProctoringOption = ({ option }: { option: (typeof proctoringOptions)[0] }) => (
	<div style={{ display: "flex", width: "33%", float: "left", marginTop: "5px" }}>
		<option.icon style={{ marginTop: "1px", color: "#42296E" }} />
		<div style={{ marginLeft: "10px" }}>{option.label}</div>
	</div>
);

export default function AssessmentSetting({ assessmentOption }: { assessmentOption: VideoEvent["details"] }) {
	return (
		<div style={{ marginTop: "40px", color: "#202124" }}>
			<div style={{ borderBottom: "1px solid #C7C7C7" }}>
				<strong>{i18n.t("result.components.resultsPage.pdfGenerator.bodyText.details")}</strong>
			</div>
			<div style={{ height: "262px", display: "block", fontSize: "18px" }}>
				<div style={{ flexBasis: "70%" }}>
					<div style={{ marginTop: "20px", marginBottom: "15px" }}>
						<div>
							<strong style={{ fontSize: "20px", lineHeight: "1.5" }}>
								{i18n.t("result.components.resultsPage.pdfGenerator.bodyText.requirements")}
							</strong>
						</div>
						<div>{i18n.t("result.components.resultsPage.pdfGenerator.bodyText.summary")}</div>
					</div>
					<div style={{ marginTop: "15px", display: "flex", flexWrap: "wrap" }}>
						{proctoringOptions.map(
							(option) =>
								assessmentOption?.options?.[option.key] !== "off" &&
								assessmentOption?.options?.[option.key] !== false && (
									<ProctoringOption key={option.key} option={option} />
								),
						)}
					</div>
				</div>
				<div>
					<div style={{ marginTop: "20px" }}>
						<div>
							<strong style={{ fontSize: "20px", lineHeight: "1.5" }}>
								{i18n.t("result.components.resultsPage.pdfGenerator.bodyText.methods")}
							</strong>
						</div>
						<div>{i18n.t("result.components.resultsPage.pdfGenerator.bodyText.methodsSummary")}</div>
					</div>
					<div style={{ marginTop: "15px" }}>
						{assessmentOption?.devicesInfo ? (
							<div style={{ display: "flex" }}>
								<BrowserExtensionIcon />
								<div style={{ marginLeft: "10px" }}>
									{i18n.t("result.components.resultsPage.pdfGenerator.bodyText.extension")}
								</div>
							</div>
						) : (
							<div style={{ display: "flex" }}>
								<LockdownAppIcon />
								<div style={{ marginLeft: "10px" }}>
									{i18n.t("result.components.resultsPage.pdfGenerator.bodyText.lockdownModule")}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
